import { createCall, spellbook } from "@sdk/spellbook";

import { withAccountAuthHeaders } from "./apiHelpers";

const endpoint = spellbook("/tasks/{id}/clone").POST();
const call = createCall(endpoint, (r) => fetch(withAccountAuthHeaders(r)));

export type DuplicateTaskParams = typeof endpoint.types.P;
export type DuplicateTaskReq = typeof endpoint.types.Req;

export async function duplicateTask({
    params,
    req,
}: {
    params: DuplicateTaskParams;
    req: DuplicateTaskReq;
}) {
    return call({ params, req });
}
